import { palette } from "../../assets/theme/theme";
import { formatDateWithHours } from "../../utils/DateUtils";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DoneIcon from '@mui/icons-material/Done';

export const getDatasOperacao = (peca: any, tipoOperacao: string | null) => {
    let start;
    let end;
    switch (tipoOperacao) {
        case 'Serrote':
            start = peca.inicioSerrote
            end = peca.fimSerrote;
            break;
        case 'CNC':
            start = peca.inicioCnc
            end = peca.fimCnc;
            break;
        case 'Acabamento':
            start = peca.inicioAcabamentos
            end = peca.fimAcabamentos;
            break;
        case 'Tratamento':
            start = peca.inicioTratamentos
            end = peca.fimTratamentos;
            break;
        case 'Convencionais':
            start = peca.inicioConvencionais
            end = peca.fimConvencionais;
            break;
        case 'Projeto':
            start = peca.inicioProjeto
            end = peca.fimProjeto;
            break;
        case 'Controlo e Qualidade':
            start = peca.inicioControloEQualdiade
            end = peca.fimControloEQualidade;
            break;
    }
    return { start: formatDateWithHours(start), end: formatDateWithHours(end) }

}


export const getEstadoOperacao = (peca: any, tipoOperacao: string | null) => {
    let response;
    switch (tipoOperacao) {
        case 'Serrote':
            response = peca.estadoSerrote;
            break;
        case 'CNC':
            response = peca.estadoCnc;
            break;
        case 'Acabamento':
            response = peca.estadoAcabamentos;    
            break;
        case 'Tratamento':
            response = peca.estadoTratamentos;
            break;
        case 'Convencionais':
            response = peca.estadoConvencionais;
            break;
        case 'Projeto':
            response = peca.estadoProjeto;
            break;
        case 'Controlo e Qualidade':
            response = peca.estadoControloEQualidade;
            break;
        case 'Expedição':
            response = peca.estadoExpedicao;
            break;
    }
    return response;
}


export const getColorByEstadoOperacao = (state: string) => {
    switch (state) {
        case 'Por iniciar':
            return palette.gray.dark;
        case 'Em andamento':
            return palette.yellow;
        case 'Concluído':
            return palette.green;
    }
}



export const getButtonTextForState = (state: string) => {
    return state == 'Por iniciar' ? 'Iniciar' : 'Terminar';
}

export const getButtonIconForState = (state: string) => {
    return state == 'Por iniciar' ? PlayArrowIcon : DoneIcon;
}